/**
 * Typ implementacji REST/FORM/SOAP
 */
export const P24ImplementationType = {

    UNKNOWN: {
        id: 0,
        name: 'UNKNOWN',
        displayText: 'Nieznany',
        isDefault: false
    },
    REST: {
        id: 1,
        name: 'REST',
        displayText: 'REST',
        isDefault: true
    },
    FORM: {
        id: 2,
        name: 'FORM',
        displayText: 'FORM',
        isDefault: false
    },
    SOAP: {
        id: 3,
        name: 'SOAP',
        displayText: 'SOAP',
        isDefault: false
    }

}

/**
 * Kolekcja implementacji
 */
export const P24ImplementationTypeList = Object.keys(P24ImplementationType).map(type => P24ImplementationType[type])

/**
 * Metoda zwracająca typ bazując na identyfikatorze
 * 
 * @param {String} id identyfikator typu  implementacji
 * 
 * @returns {P24ImplementationType} typ implementacji
 */
export const getP24ImplementationTypeById = (id) => {
    if (!id) {
        return P24ImplementationType.UNKNOWN;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24ImplementationTypeList.find(item => item.id === id)
    return type;
}

/**
 * Metoda zwracająca typ implementacji bazując na nazwie
 * 
 * @param {string} name nazwa typu implementacji
 * 
 * @returns {P24ImplementationType} typ implementacji
 */
export const getP24ImplementationTypeByName = (name) => {
    if (!name) {
        return P24ImplementationType.UNKNOWN;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24ImplementationTypeList.find(item => item.name === name)
    return type;
}